import { render, staticRenderFns } from "./material-detail-dialog.vue?vue&type=template&id=07d1bb64&scoped=true&"
import script from "./material-detail-dialog.vue?vue&type=script&lang=js&"
export * from "./material-detail-dialog.vue?vue&type=script&lang=js&"
import style0 from "./material-detail-dialog.vue?vue&type=style&index=0&id=07d1bb64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d1bb64",
  null
  
)

export default component.exports